// The main use case is to update state in response to prop changes
// see https://react.dev/reference/react/useState#storing-information-from-previous-renders
// it can only be the state of the same component that uses this hook
// make sure that all the values passed as deps are either primitives or memoized, same as with useEffect

import {useState} from 'react'

export function useSyncEffect(effect: () => void, deps: readonly unknown[]) {
  const [prevDeps, setPrevDeps] = useState<readonly unknown[]>()

  if (prevDeps == null || deps.some((dep, i) => dep !== prevDeps[i])) {
    setPrevDeps(deps)
    effect()
  }
}
